import React, {useEffect} from "react";
import "../CoursePage.sass"

export default function Olympics() {
    useEffect(() => {
        document.title = 'КьюАй - Олимпиадная математика';
    }, [])

    return <>
        <div>
            Олимпиадная математика в центре детского развития КьюАй - это возможность развить математические
            навыки вашего ребенка. Профессиональные преподаватели гарантируют индивидуальный подход и интересный
            материал, а участие в различных математических играх и соревнованиях помогут ребенку развить
            логическое мышление, концентрацию и повысить скорость решения различных задач. Наши специальные
            упражнения на развитие внимания, памяти и быстрое переключение между задачами также включены в курс.
            А наши интересные домашние задания помогут закрепить полученные знания и навыки.
        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Повышение интереса к математике;</li>
                    <li>Развитие математических способностей и нестандартного мышления;</li>
                    <li>Совершенствование знания материала школьной программы;</li>
                    <li>Углубление математических знаний в дополнение к школьной программе;</li>
                    <li>Помощь в становление успешной личности;</li>
                    <li>Расширение кругозора;</li>
                    <li>Предоставление возможности участия в олимпиадах.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-om"></div>
            </div>
        </div>
        <div>
            Олимпиадная математика в КьюАй – это уникальный курс, разработанный для ребят, которые хотят
            укрепить и расширить свои знания в математике. Мы работаем уже несколько лет и можем с гордостью
            сказать, что среди наших учеников есть немало олимпиадных призеров. Они отлично знают математику и
            готовы представлять школу на международных соревнованиях. Все наши выпускники умны, сообразительны и
            талантливы, а также всесторонне развиты. Это подтверждают многочисленные положительные отзывы от
            родителей и самих учеников.
        </div>
        <div>
            Уважаемые родители! Мы приглашаем вас присоединиться к нашему курсу в центре детского развития КьюАй
            и дать своему ребенку уникальный шанс на изучение математики на высшем уровне. Не упустите эту
            возможность, запишите своего ребенка на курс Олимпиадная математика в КьюАй уже сегодня!
        </div>
    </>
}